import { createTheme } from '@mui/material/styles'

/**
 * The customer portal's theme.
 *
 * Visually distinct from the operator console on purpose: the two are
 * different products with different audiences, and an operator who has both
 * open should never have to check the URL to know which one they are acting
 * in.
 *
 * Distinct in colour, not in build. Everything else — the type scale, the
 * font, the corner radius, the flat buttons — is deliberately the console's,
 * so the two read as one product family seen from two sides. Identity is
 * carried by the palette alone, which is the one signal that survives being
 * glanced at.
 *
 * Vazirmatn is bundled, not fetched: this network cannot reach a public font
 * CDN, and Persian text falling back to a system font usually loses its
 * numerals and its joining behaviour rather than merely changing shape. (An
 * earlier version of this comment said the stack was system-only. It was
 * wrong when written — the font has been bundled and first in the stack since
 * the beginning.)
 */
export const theme = createTheme({
  // Persian, right to left. The emotion cache in App.tsx flips the CSS these
  // components emit; this places the components themselves. Both are needed.
  direction: 'rtl',
  palette: {
    mode: 'light',
    primary: { main: '#2f6f4f' },
    secondary: { main: '#8fc0a9' },
    error: { main: '#b3261e' },
    background: { default: '#f7f9f8', paper: '#ffffff' },
  },
  typography: {
    fontFamily: [
      'Vazirmatn',
      'system-ui',
      '-apple-system',
      'Segoe UI',
      'Roboto',
      'Helvetica Neue',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: { fontSize: '1.75rem', fontWeight: 600 },
    h2: { fontSize: '1.35rem', fontWeight: 600 },
  },
  // The console's radius, not a portal-specific one. A card that is rounder
  // here than there is a difference nobody chose and everybody sees.
  shape: { borderRadius: 8 },
  components: {
    MuiButton: { defaultProps: { disableElevation: true } },
  },
})
